import { render } from "./page-home.vue?vue&type=template&id=0f6fcd8f"
import script from "./page-home.js?vue&type=script&lang=js"
export * from "./page-home.js?vue&type=script&lang=js"

import "./page-home.vue?vue&type=style&index=0&id=0f6fcd8f&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__